import { Center, Flex, Spinner, Text, VStack } from "@chakra-ui/react"
import { differenceInSeconds, format } from "date-fns"
import React from "react"
import { useUserCurrentLocationRecordQuery } from "../../graphql"
import { getDurationInWords } from "../../utils"
import { Card, Stat } from "../common"

export type UserCurrentLocationProps = {
	userId: string
}

export const UserCurrentLocation: React.FC<UserCurrentLocationProps> = ({ userId }) => {
	const [{ data, fetching, error }] = useUserCurrentLocationRecordQuery({ variables: { userId } })

	return (
		<Card title="Current Location">
			{fetching ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading current location</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.userCurrentLocationRecord ? (
				<Flex w="full" justify="space-between" align="center">
					<Stat label="Zone" value={data.userCurrentLocationRecord.zone.label.name} />
					<Stat label="Since" value={format(new Date(data.userCurrentLocationRecord.startAt), "MMM dd, yyyy HH:mm")} />
					<Stat label="Duration" value={getDurationInWords(differenceInSeconds(new Date(data.userCurrentLocationRecord.endAt), new Date(data.userCurrentLocationRecord.startAt)))} />
				</Flex>
			) : (
				<Center py="4">
					<Text fontSize="md" color="error.500">
						Couldn&apos;t find current location
					</Text>
				</Center>
			)}
		</Card>
	)
}
